import React from 'react'
import ReactDOM from 'react-dom/client'

import BookButton from './jsx/BookButton'
import BookingForm from './jsx/BookingForm'


/*var i = document.getElementById('react-booking-modal').dataset.id
console.log("hello");
console.log(i)

ReactDOM.createRoot(document.getElementById('react-booking-modal')).render(
  <React.StrictMode>
    
    <BookingModal id={i} />

  </React.StrictMode>,
)*/


document.querySelectorAll('.book-button').forEach(function(el) {
    ReactDOM.createRoot(el).render(
      <React.StrictMode>
        <BookButton eventId={el.dataset.event} productId={el.dataset.product} />
      </React.StrictMode>,
    )
})

document.querySelectorAll('.react-event-booking-form').forEach(function(el) {
  ReactDOM.createRoot(el).render(
    <React.StrictMode>
      <BookingForm productId={el.dataset.product} />
    </React.StrictMode>,
  )
})